// Central brand assets
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_mechanic-connect-71/artifacts/muj6518c_1000335256.png";

export const BRAND = {
  primary: "#3CFF7E",
  secondary: "#0B1E5B",
  accent: "#E6FF3C",
  bg: "#0A0A0A",
  card: "#111827",
  textPrimary: "#FFFFFF",
  textSecondary: "#9CA3AF",
};
